import { useMemo } from "react";

// This hook allows creating a memoized ResizeObserver, which is meant to be passed a
// memoized callback (through useCallback).
//
// The "else" condition is for IE10 which does not support this observer, but,
// implementing an alternative is complex and may be slow.
//
export const useResizeObserver = callback =>
  useMemo(
    () =>
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(callback)
        : { observe: () => {}, unobserve: () => {} },
    [callback]
  );
